import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField
} from "@material-ui/core";


import DeleteForeverIcon from '@material-ui/icons/DeleteForever';


 import React, { useState} from "react";
import axios from "axios";
import { api } from "./api/client";

export default function ModalBoxDelete(props) {
    const [open, setOpen] = useState(false);
    const [state, setState] = useState({
        id:props.id
    });



    const handleClickOpen = () => {
        setOpen(true);
    };


    const handleClose = () => {
        setOpen(false);

    };
    return (
        <div>
            <Button variant="contained" size={"small"} color="secondary" onClick={handleClickOpen }>
                <DeleteForeverIcon   />
            </Button>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Lokasyon Silme</DialogTitle>
                <DialogContentText style={{padding:20}}>
                    Silmek istediğinize emin misiniz? <br/>
                    Bu işlem geri alınamaz!
                </DialogContentText>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        İptal
                    </Button>
                    <Button
                        onClick={

                            async () => {

                             await api.delete('/lookups/lokasyonlar/' + state.id)
                                .then((response) => {
                                    // Success 🎉
                                    console.log(response);
                                    handleClose();
                                    props.locationChange(true);
                                })
                                .catch((error) => {
                                    // Error 😨
                                    if (error.response) {
                                        /*
                                         * The request was made and the server responded with a
                                         * status code that falls out of the range of 2xx
                                         */
                                        console.log(error.response.data);
                                        console.log(error.response.status);
                                        console.log(error.response.headers);
                                    } else if (error.request) {
                                        /*
                                         * The request was made but no response was received, `error.request`
                                         * is an instance of XMLHttpRequest in the browser and an instance
                                         * of http.ClientRequest in Node.js
                                         */
                                        console.log(error.request);
                                    } else {
                                        // Something happened in setting up the request and triggered an Error
                                        console.log('Error', error.message);
                                    }
                                    console.log(error.config);
                                });

                        }}
                        color="secondary"
                    >
                        Sil
                    </Button>
                </DialogActions>
            </Dialog></div>
    )
}

